export default __webpack_public_path__ + "static/media/E.d3f0fe0f.svg";